import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'website',
})
export class WebsitePipe implements PipeTransform {
  transform(value: string): string {
    if (value) {
      const splitUrl = value.split('.');
      let formattedWebsite: string = '';

      if (splitUrl[0].indexOf('www') > -1) {
        formattedWebsite = 'https://www.' + splitUrl.slice(1).join('.');
      } else if (splitUrl[0].indexOf('https') > -1) {
        formattedWebsite = value;
      } else {
        formattedWebsite = 'https://www.' + splitUrl.join('.');
      }
      return formattedWebsite;
    }

    return null;
  }
}
